(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('doubleSectorInRollingSevenDays', [
      'ui.router'
    ]);
}());
